import { Link, Outlet, useLocation } from "react-router-dom";
import {
  RedirectToSignIn,
  SignedIn,
  useAuth,
  UserButton,
  useUser,
} from "@clerk/clerk-react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import {
  Camera,
  Monitor,
  Database,
  BarChart2,
  Sidebar,
  ChevronDown,
  LayoutDashboard,
  Map,
  EarthLock,
  Check,
} from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "src/components/ui/avatar";
import logo from "../assets/images/logo_energiot.svg";
import logoSmall from "../assets/images/logo_small.svg";
import { RefreshCw } from "lucide-react";
// [tutorial disabled] import { driver } from "driver.js";
// [tutorial disabled] import { CircleHelp } from "lucide-react";
// [tutorial disabled] import "driver.js/dist/driver.css";
import { useApiFetch } from "src/lib/api";

// Dashboards available per organization product ("audio", "magnetic" or "both")
const DASHBOARD_OPTIONS = [
  { to: "/dashboard", label: "Avifauna Audio Solution", icon: LayoutDashboard, products: ["audio", "both"] },
  { to: "/dashboard-v2", label: "Avifauna Magnetic Field", icon: Map, products: ["magnetic", "both"] },
];

export default function NavLayout() {
  const { isSignedIn } = useAuth();
  const { user } = useUser();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [dashboardOpen, setDashboardOpen] = useState(false);
  const [flyoutPos, setFlyoutPos] = useState(null); // Collapsed sidebar: position of the dashboard menu
  const dashboardButtonRef = useRef(null);
  const flyoutRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate(); // Hook para redirección
  const [orgId, setOrganizationId] = useState(null);
  const apiFetch = useApiFetch();
  const [loading, setLoading] = useState(true); // Estado de carga
  const [devices, setDevices] = useState([]);
  const [product, setProduct] = useState("");
  const [role, setRole] = useState("member");
  const [orgWorkSpace, setOrgWorkSpace] = useState("");

  // [tutorial disabled] useEffect(() => {
    // [tutorial disabled] let intervalId = null;

    // [tutorial disabled] const checkForTutorialReady = () => {
      // [tutorial disabled] let step = localStorage.getItem("driver-tutorial-step");
      // [tutorial disabled] const el = document.querySelector("#side-bar");

      // [tutorial disabled] if (step === "navbar" && el) {
        // [tutorial disabled] clearInterval(intervalId);
        // [tutorial disabled] startDriver();

        // [tutorial disabled] setTimeout(() => {
          // [tutorial disabled] intervalId = setInterval(checkForTutorialReady, 300);
        // [tutorial disabled] }, 1000);
      // [tutorial disabled] }
    // [tutorial disabled] };

    // [tutorial disabled] const startDriver = () => {
      // [tutorial disabled] const driverObj = driver({
        // [tutorial disabled] steps: [
          // [tutorial disabled] {
            // [tutorial disabled] element: "#side-bar",
            // [tutorial disabled] popover: {
              // [tutorial disabled] title: "Navigation Bar",
              // [tutorial disabled] description:
                // [tutorial disabled] "This bar can be used to navigate through the website structure",
              // [tutorial disabled] prevBtnText: `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] doneBtnText: `
                  // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                  // [tutorial disabled] </svg>
                // [tutorial disabled] `,
              // [tutorial disabled] nextBtnText: `
                  // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                  // [tutorial disabled] </svg>
                // [tutorial disabled] `,
              // [tutorial disabled] onCloseClick: () => {
                // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
                // [tutorial disabled] driverObj.destroy();
              // [tutorial disabled] },
              // [tutorial disabled] onPrevClick: () => {
                // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "device-list");
              // [tutorial disabled] },
            // [tutorial disabled] },
            // [tutorial disabled] onDeselected: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] },
            // [tutorial disabled] onDestroyed: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] },
            // [tutorial disabled] onHighlighted: () => {
              // [tutorial disabled] const enablePrev = () => {
                // [tutorial disabled] const prevBtn = document.querySelector(
                  // [tutorial disabled] ".driver-popover-prev-btn"
                // [tutorial disabled] );
                // [tutorial disabled] if (prevBtn) {
                  // [tutorial disabled] prevBtn.removeAttribute("disabled");
                  // [tutorial disabled] prevBtn.classList.remove("driver-popover-btn-disabled");
                  // [tutorial disabled] clearInterval(retry);
                // [tutorial disabled] }
              // [tutorial disabled] };

              // [tutorial disabled] const retry = setInterval(enablePrev, 100);
              // [tutorial disabled] setTimeout(() => clearInterval(retry), 1000);
            // [tutorial disabled] },
          // [tutorial disabled] },
          // [tutorial disabled] {
            // [tutorial disabled] element: "#sidebar-content",
            // [tutorial disabled] popover: {
              // [tutorial disabled] title: "Website sections",
              // [tutorial disabled] prevBtnText: `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] doneBtnText: `
                  // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                  // [tutorial disabled] </svg>
                // [tutorial disabled] `,
              // [tutorial disabled] nextBtnText: `
                  // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                  // [tutorial disabled] </svg>
                // [tutorial disabled] `,
              // [tutorial disabled] onCloseClick: () => {
                // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
                // [tutorial disabled] driverObj.destroy();
              // [tutorial disabled] },
            // [tutorial disabled] },
            // [tutorial disabled] onDeselected: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] },
            // [tutorial disabled] onDestroyed: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] },
          // [tutorial disabled] },
          // [tutorial disabled] {
            // [tutorial disabled] element: "#sidebar-footer",
            // [tutorial disabled] popover: {
              // [tutorial disabled] title: "User actions",
              // [tutorial disabled] description:
                // [tutorial disabled] "This section can be used to swap organizations or manage your account",
              // [tutorial disabled] prevBtnText: `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] doneBtnText: `
                  // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                  // [tutorial disabled] </svg>
                // [tutorial disabled] `,
              // [tutorial disabled] nextBtnText: `
                  // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                  // [tutorial disabled] </svg>
                // [tutorial disabled] `,
              // [tutorial disabled] onNextClick: () => {
                // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "livestreaming");
                // [tutorial disabled] navigate("/livestreaming");
              // [tutorial disabled] },
              // [tutorial disabled] onCloseClick: () => {
                // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
                // [tutorial disabled] driverObj.destroy();
              // [tutorial disabled] },
            // [tutorial disabled] },
            // [tutorial disabled] onDeselected: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] },
            // [tutorial disabled] onDestroyed: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] },
          // [tutorial disabled] },
        // [tutorial disabled] ],
      // [tutorial disabled] });

      // [tutorial disabled] driverObj.drive();
    // [tutorial disabled] };

    // [tutorial disabled] intervalId = setInterval(checkForTutorialReady, 300);

    // [tutorial disabled] return () => {
      // [tutorial disabled] if (intervalId) clearInterval(intervalId);
    // [tutorial disabled] };
  // [tutorial disabled] }, []);

  useEffect(() => {
    const checkIsMobile = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (mobile) setSidebarOpen(false);
    };
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  // Cerrar el menú desplegable del dashboard cuando cambia la ruta
  useEffect(() => {
    setDashboardOpen(false);
  }, [location.pathname]);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const toggleDashboard = (e) => {
    e.preventDefault();
    if (!dashboardOpen && !sidebarOpen && dashboardButtonRef.current) {
      const rect = dashboardButtonRef.current.getBoundingClientRect();
      setFlyoutPos({ top: rect.top, left: rect.right + 12 });
    }
    setDashboardOpen(!dashboardOpen);
  };

  // Collapsed sidebar menu: close on outside click, Escape, scroll or resize
  const collapsedMenuOpen = dashboardOpen && !sidebarOpen;
  useEffect(() => {
    if (!collapsedMenuOpen) return;
    const close = () => setDashboardOpen(false);
    const onPointerDown = (e) => {
      if (flyoutRef.current?.contains(e.target) || dashboardButtonRef.current?.contains(e.target)) return;
      close();
    };
    const onKeyDown = (e) => {
      if (e.key !== "Escape") return;
      close();
      dashboardButtonRef.current?.focus();
    };
    const onScroll = (e) => {
      if (!flyoutRef.current?.contains(e.target)) close();
    };
    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    window.addEventListener("scroll", onScroll, true);
    window.addEventListener("resize", close);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
      window.removeEventListener("scroll", onScroll, true);
      window.removeEventListener("resize", close);
    };
  }, [collapsedMenuOpen]);

  // [tutorial disabled] const enableTutorial = async () => {
    // [tutorial disabled] try {
      // [tutorial disabled] const data = await apiFetch("/auth/enable-tutorial", { method: "POST" });
      // [tutorial disabled] if (!data) return;
      // [tutorial disabled] navigate("/index");
      // [tutorial disabled] window.location.reload();
    // [tutorial disabled] } catch (error) {
      // [tutorial disabled] console.error("Error enabling tutorial:", error);
    // [tutorial disabled] }
  // [tutorial disabled] };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await apiFetch("/auth/auth-org-name");
        if (!data) return;

        setOrgWorkSpace(data ?? {});
      } catch (error) {
        console.error("Error fetching devices:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setOrganizationId(orgId);
      setLoading(true);

      try {
        const data = await apiFetch("/api/dashboard-default");
        if (!data) return;

        setDevices(data?.devicesNames ?? []);
        setProduct(data?.product?.product);
        setRole(data?.role || "member")
        /* console.log("[DEBUG] Role set to:", data?.role || "member"); */

      } catch (error) {
        console.error("Error fetching devices:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleToggle = (checked) => {
    navigate("/org-selector");
  };

  if (!isSignedIn) return <RedirectToSignIn />;

  // const role = user.organizationMemberships[0].role;

  const isActive = (path) => location.pathname === path;
  const isDashboardActive = isActive("/dashboard") || isActive("/dashboard-v2");
  const dashboardOptions = DASHBOARD_OPTIONS.filter((option) => option.products.includes(product));
  const singleDashboard = dashboardOptions.length === 1 ? dashboardOptions[0] : null;

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      {isMobile && sidebarOpen && (
        <div
          className="fixed inset-0 z-[9999] bg-black bg-opacity-50 transition-opacity duration-300"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div
        id="side-bar"
        className={`fixed md:relative z-[10000] h-full transition-all duration-300 ease-in-out bg-custom-blue border-custom-blue ${
          sidebarOpen ? "w-64" : isMobile ? "-translate-x-full" : "w-20"
        } ${isMobile && sidebarOpen ? "shadow-xl" : ""}`}
      >
        {/* Sidebar Header */}
        <div className="relative h-16 bg-custom-blue border-custom-blue-dark flex items-center justify-center">
          <Link
            to="/index"
            className="z-[10] flex items-center justify-center w-full h-full"
          >
            {sidebarOpen ? (
              <img
                src={logo || "/placeholder.svg"}
                alt="Energiot Logo"
                className="h-14 w-auto object-contain transition-all duration-300 ease-in-out mt-4"
              />
            ) : (
              <img
                src={logoSmall || "/placeholder.svg"}
                alt="Energiot Logo Pequeño"
                className="h-8 w-auto object-contain transition-all duration-300 ease-in-out"
              />
            )}
          </Link>
        </div>

        {/* Sidebar Content */}
        <div className="py-6 bg-custom-blue h-full overflow-auto custom-scrollbar">
          <div className={`px-3 mb-6 ${sidebarOpen ? "block" : ""}`}>
            <div
              className={`text-xs font-semibold text-white uppercase tracking-wider ${
                sidebarOpen ? "px-3" : "px-2"
              } opacity-70 text-wrap`}
            >
              {sidebarOpen ? (
                <div>Principal - {orgWorkSpace?.name}</div>
              ) : (
                <Avatar className="h-8 w-8 z-1000">
                  <AvatarImage
                    src={orgWorkSpace?.image || "/placeholder.svg"}
                    alt={orgWorkSpace?.name}
                  />
                  <AvatarFallback className="bg-white opacity-100 text-custom-blue">
                    {orgWorkSpace?.name?.toString().substring(0, 2) || ""}
                  </AvatarFallback>
                </Avatar>
              )}
            </div>
          </div>

          <ul className="space-y-1 px-3" id="sidebar-content">
            <li>
              <Link
                to="/livestreaming"
                aria-current={isActive("/livestreaming") ? "page" : undefined}
                className={`sidebar-item flex items-center px-3 py-2.5 rounded-lg group no-underline text-white ${
                  isActive("/livestreaming") ? "is-active" : ""
                } ${sidebarOpen ? "justify-start" : "justify-center"}`}
              >
                <Monitor className="w-5 h-5 text-white" />
                {sidebarOpen && (
                  <span className="ml-3 font-medium text-white">
                    Live-streaming
                  </span>
                )}
                {!sidebarOpen && (
                  <span className="absolute left-full ml-6 px-2 py-1 text-xs font-medium text-white bg-custom-blue-dark rounded-md invisible opacity-0 -translate-x-3 group-hover:visible group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 z-[10001]">
                    Live-streaming
                  </span>
                )}
              </Link>
            </li>
            <li>
              <Link
                to="/detection"
                aria-current={isActive("/detection") ? "page" : undefined}
                className={`sidebar-item flex items-center px-3 py-2.5 rounded-lg group no-underline text-white ${
                  isActive("/detection") ? "is-active" : ""
                } ${sidebarOpen ? "justify-start" : "justify-center"}`}
              >
                <Camera className="w-5 h-5 text-white" />
                {sidebarOpen && (
                  <span className="ml-3 font-medium text-white">
                    Detections
                  </span>
                )}
                {!sidebarOpen && (
                  <span className="absolute left-full ml-6 px-2 py-1 text-xs font-medium text-white bg-custom-blue-dark rounded-md invisible opacity-0 -translate-x-3 group-hover:visible group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 z-[10001]">
                    Detections
                  </span>
                )}
              </Link>
            </li>
            {role === "admin" && (
              <li>
                <Link
                  to="/devicemanager"
                  aria-current={isActive("/devicemanager") ? "page" : undefined}
                  className={`sidebar-item flex items-center px-3 py-2.5 rounded-lg group no-underline text-white ${
                    isActive("/devicemanager") ? "is-active" : ""
                  } ${sidebarOpen ? "justify-start" : "justify-center"}`}
                >
                  <Database className="w-5 h-5 text-white" />
                  {sidebarOpen && (
                    <span className="ml-3 font-medium text-white">
                      Device Manager
                    </span>
                  )}
                  {!sidebarOpen && (
                    <span className="absolute left-full ml-6 px-2 py-1 text-xs font-medium text-white bg-custom-blue-dark rounded-md invisible opacity-0 -translate-x-3 group-hover:visible group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 z-[10001]">
                      Device Manager
                    </span>
                  )}
                </Link>
              </li>
            )}

            {/* Dashboard con menú desplegable */}
            {dashboardOptions.length > 0 && (
            <li className="relative">
              {sidebarOpen ? (
                <>
                  {/* Versión expandida con dropdown */}
                  <button
                    onClick={toggleDashboard}
                    aria-expanded={dashboardOpen}
                    className={`sidebar-item flex items-center justify-between w-full px-3 py-2.5 rounded-lg group no-underline text-white ${
                      isDashboardActive ? "is-active" : ""
                    }`}
                  >
                    <div className="flex items-center">
                      <BarChart2 className="w-5 h-5 text-white" />
                      <span className="ml-3 font-medium text-white">
                        Dashboard
                      </span>
                    </div>
                    <ChevronDown
                      className={`w-4 h-4 text-white transition-transform duration-200 ${
                        dashboardOpen ? "transform rotate-180" : ""
                      }`}
                    />
                  </button>

                  {/* Menú desplegable */}
                  {dashboardOpen && (
                    <div className="mt-1 ml-7 pl-4 border-l border-white border-opacity-20 space-y-1">
                      {dashboardOptions.map(({ to, label, icon: Icon }) => (
                        <Link
                          key={to}
                          to={to}
                          aria-current={isActive(to) ? "page" : undefined}
                          className={`sidebar-subitem flex items-center px-3 py-2 rounded-md text-sm no-underline ${
                            isActive(to) ? "is-active" : ""
                          }`}
                        >
                          <Icon className="w-4 h-4 mr-2" />
                          <span>{label}</span>
                        </Link>
                      ))}
                    </div>
                  )}
                </>
              ) : singleDashboard ? (
                /* Versión contraída, un solo dashboard: enlace directo */
                <Link
                  to={singleDashboard.to}
                  aria-label={`Dashboard: ${singleDashboard.label}`}
                  aria-current={isActive(singleDashboard.to) ? "page" : undefined}
                  className={`sidebar-item flex items-center justify-center px-3 py-2.5 rounded-lg group no-underline text-white ${
                    isActive(singleDashboard.to) ? "is-active" : ""
                  }`}
                >
                  <BarChart2 className="w-5 h-5 text-white" />
                  <span className="absolute left-full ml-6 px-2 py-1 text-xs font-medium text-white bg-custom-blue-dark rounded-md whitespace-nowrap invisible opacity-0 -translate-x-3 group-hover:visible group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 z-[10001]">
                    {singleDashboard.label}
                  </span>
                </Link>
              ) : (
                /* Versión contraída, varios dashboards: menú flotante para elegir */
                <>
                  <button
                    ref={dashboardButtonRef}
                    onClick={toggleDashboard}
                    aria-label="Dashboard: choose a dashboard"
                    aria-haspopup="menu"
                    aria-expanded={dashboardOpen}
                    className={`sidebar-item flex items-center justify-center w-full px-3 py-2.5 rounded-lg group ${
                      isDashboardActive || dashboardOpen ? "is-active" : ""
                    }`}
                  >
                    <BarChart2 className="w-5 h-5 text-white" />
                    <span className="sidebar-item-count" aria-hidden="true">
                      {dashboardOptions.length}
                    </span>
                  </button>

                  {collapsedMenuOpen && flyoutPos &&
                    createPortal(
                      <div
                        ref={flyoutRef}
                        role="menu"
                        aria-label="Dashboards"
                        className="sidebar-flyout"
                        style={{ top: flyoutPos.top, left: flyoutPos.left }}
                      >
                        <div className="sidebar-flyout-title">Choose a dashboard</div>
                        {dashboardOptions.map(({ to, label, icon: Icon }) => (
                          <Link
                            key={to}
                            to={to}
                            role="menuitem"
                            aria-current={isActive(to) ? "page" : undefined}
                            onClick={() => setDashboardOpen(false)}
                            className={`sidebar-subitem flex items-center gap-2 px-3 py-2 rounded-md text-sm no-underline ${
                              isActive(to) ? "is-active" : ""
                            }`}
                          >
                            <Icon className="w-4 h-4 shrink-0" />
                            <span className="flex-1">{label}</span>
                            {isActive(to) && <Check className="w-4 h-4 shrink-0" aria-hidden="true" />}
                          </Link>
                        ))}
                      </div>,
                      document.body
                    )}
                </>
              )}
            </li>
            )}
          </ul>
        </div>

        {/* Sidebar Footer */}
        <div
          id="sidebar-footer"
          className="absolute bottom-0 w-full border-custom-blue-dark bg-custom-blue"
        >
          <div className="p-2">
            {/* [tutorial disabled] Tutorial button
            <button
              className={`flex items-center mb-1 w-full px-4 py-2.5 rounded-lg group transition-all duration-200 no-underline text-white ${
                sidebarOpen ? "justify-start" : "justify-center"
              }`}
              onClick={enableTutorial}
            >
              <CircleHelp className="w-5 h-5 text-white" />
              {sidebarOpen && (
                <span className="ml-3 font-normal text-white">Tutorial</span>
              )}
              {!sidebarOpen && (
                <span className="absolute left-full ml-6 px-2 py-1 text-xs font-normal text-white bg-custom-blue-dark rounded-md invisible opacity-0 -translate-x-3 group-hover:visible group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 z-[10001]">
                  Tutorial
                </span>
              )}
            </button>
            */}
            <button
              className={`sidebar-item flex items-center mb-1 px-4 w-full py-2.5 rounded-lg group no-underline text-white ${
                sidebarOpen ? "justify-start" : "justify-center"
              }`}
              onClick={handleToggle}
            >
              <RefreshCw className="w-5 h-5 text-white" />
              {sidebarOpen ? (
                <span className="ml-3 font-normal text-white">
                  Swap organizations
                </span>
              ) : (
                <span className="absolute left-full ml-6 px-2 py-1 text-xs font-normal text-white bg-custom-blue-dark rounded-md invisible opacity-0 -translate-x-3 group-hover:visible group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 z-[10001]">
                  Swap organizations
                </span>
              )}
            </button>

            {sidebarOpen ? (
              <div className="flex items-center space-x-3 ml-16">
                <SignedIn>
                  <UserButton />
                </SignedIn>
                <div className="flex-1 min-w-0 mt-3">
                  <p className="text-sm font-medium text-white">My account</p>
                </div>
              </div>
            ) : (
              <div className="flex justify-center mb-3">
                <SignedIn>
                  <UserButton />
                </SignedIn>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex flex-col flex-1 overflow-hidden">
        <header className="flex items-center justify-between h-16 px-4 bg-white relative z-[9000]">
          <button
            onClick={toggleSidebar}
            className="p-2 rounded-md hover:bg-gray-100 transition"
          >
            <Sidebar
              className={`w-6 h-6 ${
                sidebarOpen ? "text-gray-700" : "text-gray-500"
              }`}
            />
          </button>
        </header>
        <main className="flex-1 min-w-0 overflow-auto bg-gray-50 p-3 sm:p-6 relative z-[8000]">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
